import { clsx } from 'clsx';
import { FC, ReactNode } from 'react';

import { styled } from '@mui/material/styles';
import UiTabs, { TabsProps as UiTabsProps } from '@o2/ui/Tabs';

import { BaseColorList } from '@o2/ui/theme/colorList';

import { useSubheaderUtilityClasses } from '../subheaderClasses';
import Box from '@o2/ui/Box';

type SubheaderTabsProps = UiTabsProps & {
  children: ReactNode;
  color?: BaseColorList;
};

const StyledTabs = styled(UiTabs)(() => ({
  borderBottom: 'none',
}));

const Tabs: FC<SubheaderTabsProps> = ({ children, classes, color = 'primary', ...props }) => {
  const utilityClasses = useSubheaderUtilityClasses(classes);

  return (
    <Box order={5}>
      <StyledTabs
        allowScrollButtonsMobile
        className={clsx(utilityClasses.tabs)}
        indicatorColor={color}
        scrollButtons="auto"
        variant="scrollable"
        {...props}
      >
        {children}
      </StyledTabs>
    </Box>
  );
};

Tabs.displayName = 'Subheader.Tabs';

export default Tabs;
